import { render, staticRenderFns } from "./EditOwnCourse.vue?vue&type=template&id=63016b90"
import script from "./EditOwnCourse.vue?vue&type=script&lang=js"
export * from "./EditOwnCourse.vue?vue&type=script&lang=js"
import style0 from "./EditOwnCourse.vue?vue&type=style&index=0&id=63016b90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports